import { ReactNode } from 'react';
import { appConfig } from '@@config/appConfig';

export const DebugOnly = ({ children }: { children: ReactNode }) => {
  if (!appConfig.debug) return null;

  return <>{children}</>;
};
